"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ProfilePrivacyFillYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ProfilePrivacyFillYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM7 9c-4.2 0-7 1.88-7 4.2A2.8 2.8 0 0 0 2.8 16h6.979a6.447 6.447 0 0 1-1.395-1.396c-.964-1.316-1.548-3.147-1.331-5.549A1.35 1.35 0 0 1 7.059 9H7Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ProfilePrivacyFillYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131619",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_ProfilePrivacyFillYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 8,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.338 8.9c-.148 0-.284.101-.297.244-.394 4.371 2.133 6.34 3.93 6.852a.103.103 0 0 0 .057 0c1.798-.512 4.325-2.48 3.93-6.852-.012-.143-.148-.245-.296-.243-1.388.014-2.857-1.264-3.422-1.811a.366.366 0 0 0-.48 0c-.565.547-2.034 1.825-3.422 1.81Z",
    fill: "#3B90F7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ProfilePrivacyFillYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B90F7",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ProfilePrivacyFillYes;
exports["default"] = _default;